<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          @serviceLocation="getSpecialists"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import providerApi from '@/services/api/provider.api';
import LocationServices from '@/services/api/locationService.api';
import SpecialistServices from '@/services/api/specialist.api';
import ROLE from '@/utils/role';
import { modulesName } from '@/store';

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Detalle de Referidos',
      routes: ['Informes', 'Informe de Detalle de Referidos'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          serviceLocations: [],
          specialists: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          specialist: null,
          serviceLocation: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangedAcademicYears,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un proveedor.',
          validations: 'required',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          clearable: false,
          class: 'col-md-3',
          disabled: this.model.search.collections.providers.length <= 1,
          onChanged: () => {
            this.onProviderChange();
          },
        },
        {
          name: 'serviceLocation',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Lugar de servicio',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un lugar de servicio.',
          clearable: false,
          class: 'col-md-3',
          options: this.model.search.collections.serviceLocations,
          value: this.model.search.filters.serviceLocation,
          disabled: this.model.search.collections.serviceLocations.length <= 1,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un especialista.',
          clearable: false,
          class: 'col-md-3',
          options: this.model.search.collections.specialists,
          disabled: this.model.search.collections.specialists.length <= 1,
          value: this.model.search.filters.specialist,
        },
      ];
    },
    isSpecialist() {
      return this.userRole === ROLE.Especialista;
    },
  },
  async mounted() {
    await this.setFilters();
    if (this.isSpecialist) {
      this.model.search.collections.providers = this.$store.getters[
        `${modulesName.userModuleName}/companies`
      ];
      this.model.search.filters.provider = this.model.search.collections.providers[0];
      this.model.search.filters.academicYear = this.model.search.collections.academicYears[0];
      this.getSpecialists();
      this.getServiceLocations();
    }
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      );
    },
    async onChangedAcademicYears() {
      if (!this.isSpecialist) this.model.search.filters.provider = null;
      this.model.search.filters.serviceLocation = null;
      this.model.search.filters.specialist = null;

      this.model.search.collections.serviceLocations = [];
      this.model.search.collections.specialists = [];

      this.getProvider();
      this.getSpecialists();
      this.getServiceLocations();
    },
    async getProvider() {
      await providerApi
        .getAllProvidertCompaniesByYear({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.providers = res.data;
          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0];
            this.onProviderChange();
          }
        });
    },
    async getServiceLocations() {
      if (this.model.search.filters.provider?.id) {
        await LocationServices.getServiceLocations(
          this.model.search.filters.provider.id,
          {
            academicYearId: this.model.search.filters.academicYear?.id,
          }
        ).then(({ data }) => {
          this.model.search.collections.serviceLocations = data.map((item) => ({
            ...item,
            id: item.id,
            description: item.name,
          }));
          if (data.length == 1) {
            this.model.search.filters.serviceLocation = this.model.search.collections.serviceLocations[0];
            this.getSpecialists();
          }
        });
      }
    },
    onProviderChange() {
      this.model.search.filters.serviceLocation = null;
      this.model.search.filters.specialist = null;
      this.model.search.collections.serviceLocations = [];
      this.model.search.collections.specialists = [];
      this.getServiceLocations();

      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];
      this.getSpecialists();
    },
    getSpecialists() {
      if (this.model.search.filters.provider?.id) {
        const payload = {
          fiscalYearId: this.model.search.filters.academicYear?.id,
          providerId: this.model.search.filters.provider?.id,
          locationServiceId: this.model.search.filters.serviceLocation?.id
        }        
        SpecialistServices.getSpecialist(payload).then(({ data }) => {
          this.model.search.collections.specialists = data.map((item) => ({
            ...item,
            id: item.id,
            description: item.name,
          }));
          if (data.length == 1) {
            this.model.search.filters.specialist = {
              ...data[0],
              id: data[0].id,
              description: data[0].name,
            };
          }
        });
      }
    },
    async onHandlerSearch() {
      this.process();
    },
    async process() {
      if (
        this.model.search.filters.academicYear?.id &&
        this.model.search.filters.provider?.id
      ) {
        const serviceLocationId = (
          this.model.search.filters.serviceLocation || {}
        ).id;
        const specialistId = (this.model.search.filters.specialist || {}).id;

        await ReportServices.getReport('referraldetail', {
          academicYearId: this.model.search.filters.academicYear.id,
          companyId: this.model.search.filters.provider.id,
          serviceLocationId,
          specialistId,
        }).then((res) => DocumentServices.Download(res.data));
      }
    },
  },
};
</script>
